import type { AutomationDetailsViewModel } from '../../view-model/AutomationDetails.viewModel';
import { MonthlyToAnnualConfigView } from './MonthlyToAnnualConfig.view';
import { OtpPitchTargetConfigView } from './OtpPitchTargetConfig.view';
import { TrialNurtureConfigView } from './TrialNurtureConfig.view';

/** Which "What we need from you" form a type shows in the details modal.
 *  Types without an entry render the server's readiness reason only. */
export const renderAutomationConfigForm = (
  creatorId: number,
  details: AutomationDetailsViewModel,
) => {
  switch (details.automationType) {
    case 'trial_conversion':
      return <TrialNurtureConfigView creatorId={creatorId} details={details} />;
    case 'monthly_to_annual':
      return (
        <MonthlyToAnnualConfigView creatorId={creatorId} details={details} />
      );
    case 'otp_to_subscription':
      return (
        <OtpPitchTargetConfigView creatorId={creatorId} details={details} />
      );
    default:
      return null;
  }
};
